import React, {Component} from 'react';
import {AJAX, hidePreloader, showPreloader} from "../functions";
import OTPInput from "react-otp-input";
import Popup from "./Popup";
import {showPopupWithGoBack} from "./PopupWithGoBack";

class AuthCodePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {pinCode: '', hasErrorCode:false, errorCodeText: ''};

        this.sendForCodeVerify = this.sendForCodeVerify.bind(this);
        this.onChangePinCode = this.onChangePinCode.bind(this);
        this.handleClosePopup = this.handleClosePopup.bind(this);
        this.sendCode = this.sendCode.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.showPopup === 0 && this.props.showPopup === 1 && this.props.handleSendCode !== "function") {
            this.sendCode(new Event('click'));
        }
    }

    sendCode(event) {
        event.preventDefault();

        if (typeof this.props.handleSendCode === "function") {
            this.props.handleSendCode(event);
            return false;
        }

        let t = this;

        if (t.props.email.length === 0)
            return false;

        let params = {
            email: t.props.email,
            action: 'api/booking/login'
        };
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            // func_waiting: showPreloader,
            func_callback: function (resp) {
                // hidePreloader();
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    handleClosePopup() {
        this.props.handleClosePopup();
        this.setState({pinCode: '', hasErrorCode:false, errorCodeText: ''})
    }

    onChangePinCode(pinCode) {
        this.setState({ pinCode });
    }


    sendForCodeVerify(code) {
        let t = this;

        if (t.props.email.length === 0)
            return false;

        let params = {
            email: t.props.email,
            code: code,
            action: 'api/booking/check_auth_code'
        };
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1) {
                    t.handleClosePopup();
                    if (typeof t.props.handleSuccessfulRequest === "function") {
                        t.props.handleSuccessfulRequest();
                    }
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                    let errs_f = {};
                    if (resp.errors !== undefined && resp.errors.form !== undefined) {
                        errs_f = resp.errors.form;
                    }
                    if (errs_f.code) {
                        t.setState({hasErrorCode: true, errorCodeText: errs_f.code});
                    }
                    // cross_form_errors(errs_f, ['email'], form_inputs);
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    render() {
        return (
            <Popup open={this.props.showPopup}
                   modal
                   lockScroll
                   closeOnDocumentClick={false}
                   className={"bm-modal"}
            >
                <>
                    <button type="button" className="close" aria-label="Close" onClick={this.handleClosePopup}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="clearfix" />
                    <div className="col-12 text-center">
                        {
                            this.props.already_auth ? (
                                <p>Such an email already exists and if you want to save, enter the code that was sent to you by the email you entered</p>
                            ) : (
                                <p>A code has been sent to your email, enter it for authorization</p>
                            )
                        }
                        <p><a className="blue-link" onClick={this.sendCode}>Resend Code</a></p>
                        <div className={"form-group mb-4" + (this.state.hasErrorCode ? ' error-pin-code' : '')}>
                            <OTPInput
                                value={this.state.pinCode}
                                onChange={ (value) => {
                                    this.onChangePinCode(value);
                                    if (value.length === 5) {
                                        this.sendForCodeVerify(value);
                                    }
                                }}
                                numInputs={5}
                                isInputNum
                                shouldAutoFocus
                                inputStyle={{
                                    width: "2.5rem",
                                    height: "2.5rem",
                                    margin: "0 0.5rem",
                                    fontSize: "1.5rem",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc"
                                }}
                            />
                            <div id="code_errors" className={(this.state.hasErrorCode ? 'error-text': 'd-none')}>{this.state.errorCodeText}</div>
                        </div>
                    </div>
                </>
            </Popup>
        );
    }
}

export default AuthCodePopup;